import React, { useEffect } from 'react';
import { Button, Grid } from '@material-ui/core';
import ModalWithHeader from '../../../common/components/presentation/ModalWithHeader';
import Translation from '../translation/Translation';
import Typography from '@material-ui/core/Typography';
import { useIntl } from 'react-intl';
import softLockModalStyles from './softLockModalStyles';
import useStockLockContext from '../../../gqlCustomise/context/stockLock/useStockLockContext';
import useCustomizeCarContext from '../../../gqlCustomise/hooks/useCustomizeCarContext';
import useUrlSearchParams from '../../../gqlCustomise/hooks/useUrlSearchParams';
import { UrlSearchParamType } from '../../../gqlCustomise/enum/UrlSearchParamType';

const SoftLockModal = () => {
  const styles = softLockModalStyles();
  const intl = useIntl();
  const { showStockLockModal, setShowStockLockModal } = useStockLockContext();
  const { searchParams, setUrlSearchParams } = useUrlSearchParams();
  const { selectedCar, loadCustomizeCar } = useCustomizeCarContext();
  const byoCode = searchParams[UrlSearchParamType.REVERT_TO_BYO] || selectedCar?.car?.byoCode;
  const noModal = searchParams[UrlSearchParamType.NO_MODAL];

  useEffect(() => {
    if ((showStockLockModal || noModal) && byoCode) {
      setUrlSearchParams({
        ...searchParams,
        [UrlSearchParamType.REVERT_TO_BYO]: null,
        [UrlSearchParamType.CAR_CODE]: byoCode,
        [UrlSearchParamType.NO_MODAL]: null,
      });
    }
  }, [showStockLockModal, searchParams, byoCode, setUrlSearchParams, noModal]);

  const onConfirm = () => {
    setShowStockLockModal(false);
    loadCustomizeCar();
  };

  return (
    <ModalWithHeader
      open={showStockLockModal}
      data-test="modal:soft_lock"
      toggleModal={() => setShowStockLockModal(false)}
      className={styles.modal}
    >
      <Grid container className={styles.root} data-test="modal:soft_lock:content">
        <Grid item xs={12}>
          <Typography
            className={styles.message}
            dangerouslySetInnerHTML={{
              __html: intl.formatMessage({
                id: 'trans__configurator__customise_page__out_of_stock_modal__customer_message',
              }),
            }}
          />
        </Grid>
        <Grid item xs={12} className={styles.buttonContainer}>
          <Button
            data-test="button:soft_lock_continue"
            onClick={onConfirm}
            variant="contained"
            className={styles.softLockContinueBtn}
          >
            <Translation id="trans__configurator__customise_page__out_of_stock_modal__ok_cta" />
          </Button>
        </Grid>
      </Grid>
    </ModalWithHeader>
  );
};

export default SoftLockModal;
